import axios from "axios";

/**
 * API client
 */
class api {

	/**
	 * Make a request.
	 *
	 * @param {Object} request Axios request object
	 * @return {Promise} Resolves to an Axios request outcome
	 */
	static call(request) {
		return this.axios(request).request(request);
	}


	/**
	 * Create a new Axios instance for a request with our configuration.
	 *
	 * @param {Object} request Axios request object
	 * @return {Object} Axios instance
	 */
	static axios(request) {

		const instance = axios.create({
			baseURL: this.baseURL,
			headers: this.getRequestHeaders(request),
			timeout: 60000,
			withCredentials: true
		});

		// Add request interceptors
		const requestInterceptors = this.getRequestInterceptors?.(request);

		if (requestInterceptors) {
			instance.interceptors.request.use(
				requestInterceptors.config,
				requestInterceptors.error
			);
		}

		// Add response interceptors
		const responseInterceptors = this.getResponseInterceptors?.(request);

		if (responseInterceptors) {
			instance.interceptors.response.use(
				responseInterceptors.response,
				responseInterceptors.error
			);
		}

		return instance;

	}


	/**
	 * Get all currently active headers to apply to a request.
	 * 
	 * @param {Object} request Axios request object
	 * @return {Object}
	 */
	static getRequestHeaders(request) {
		return {...this.headers, ...(this.getHeaders?.(request) || {})};
	}


	/**
	 * API base URL.
	 *
	 * @type {String}
	 */
	static baseURL = "https://api.hops.org.uk";

	/**
	 * Headers to add to all requests.
	 *
	 * @type {Object}
	 */
	static headers = {};

	/**
	 * Get headers to add to all requests.
	 * 
	 * Consumers can override this to dynamically add headers.
	 * 
	 * @type {Function}
	 */
	static getHeaders = null;

	/**
	 * Get request interceptors to add to all requests.
	 * 
	 * Consumers can override this to dynamically add interceptors.
	 * 
	 * @type {Function}
	 */
	static getRequestInterceptors = null;

	/**
	 * Get response interceptors to add to all requests.
	 * 
	 * Consumers can override this to dynamically add interceptors.
	 * 
	 * @type {Function}
	 */
	static getResponseInterceptors = null;

}

export default api;
